<template>
  <div>
    <!-- <app-monev_topbar></app-monev_topbar>
    <app-monev_left_sidebar></app-monev_left_sidebar>-->
    <section class="content">
      <div class="container-fluid">
        <div class="row clearfix">
          <div class="bg-cyan" style="margin-top:-1% !important;">
            <!-- <br> -->
            <div class="row paddingku">
              <div class="col-md-3 searching">
                <span class="h_page">User e-Office</span>
                <br>
                <br>
              </div>
              <div class="col-md-6"></div>
              <div class="col-md-3 searching">
                <div class="input-group">
                  <span class="input-group-btn">
                    <button type="button" class="btn bg-orange btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data">
                      <i class="material-icons">add</i>
                    </button>
                  </span>
                  <input type="text" class="form-control" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                </div> <br>
              </div>
            </div>
          </div>
          <div class="col-xs-12 card">
      <!-- ============================================================ MULAI ======================================================================== -->
            <br>
          <!-- ============================================================ TABEL ======================================================================== -->
            <div class="table-responsive">
              <table class="table table-bordered" style="width: 100%">

                <thead>
                  <tr class="bg-info">
                    <th style="width: 5%">No.</th>
                    <th style="width: 20%">Nama</th>
                    <th style="width: 30%">Sekolah</th>
                    <th style="width: 30%">Jabatan</th>
                    <th style="width: 15%">#</th>
                  </tr>
                </thead>

                <tbody>

                    <!-- <template v-for="dn_akun in data.akun_detil" track-by="data11._id" > -->
                      <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                        <td>{{index+1}}.</td>
                        <td>{{data.profile.nama}}</td>
                        <td>{{data.profile.detilSekolah.type}} {{data.profile.detilSekolah.status}} {{data.profile.detilSekolah.sekolah}}</td>
                        <td>{{data.profile.jabatan}}</td>
                        <td class="text-center">

                          <button @click="getEdit(data.profile.detilSekolah.type, data.profile.detilSekolah.status, data.profile.detilSekolah.sekolah, data.profile.detilSekolah.id, data.profile.nama, data.profile.jabatan, data.profile.alamat, data.profile.hp, data.profile.nip, data.id, data.profile.level, data.username, data.password)" class="btn bg-light-blue btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_lihat_data">
                            <i class="material-icons">search</i>
                          </button>

                          <!-- <button @click="getEdit(data.id, data.nama, data.nip, data.hp, data.bidang, data.detil_jabatan.jabatan, data.detil_jabatan.id, data.detil_atasan.nama, data.detil_atasan.id)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                            <i class="material-icons">create</i>
                          </button> -->

                          <button class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data" >
                            <i class="material-icons">clear</i>
                          </button>

                        </td>
                      </tr>
                    <!-- </template> -->

                </tbody>

              </table>

            </div>
          <!-- ============================================================ TABEL ======================================================================== -->
            <hr>


            <div class="text-center">
              <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                <i class="material-icons">skip_previous</i>
              </button>

              <span style="font-size: 85%; color: #a5a5a5">
                <b>{{page_first}} - {{page_last}}</b>
              </span>

              <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                <i class="material-icons">skip_next</i>
              </button>
            </div>
            <hr>

        <!-- ============================================================ MODAL ======================================================================== -->


          <!-- =========================================================== TAMBAH ================================================================= -->
            <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-header bg-light-blue">
                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                  </div>

                  <div class="modal-body">
                    <div v-if="errorMessage" class="alert alert-danger" role="alert">{{ errorMessage }}</div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Unit Kerja</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <input type="text" id="unit_kerja" class="form-control" >
                            <input type="text" id="unit_kerja_id" class="form-control" style="display:none">
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Nama User</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <input type="text" id="nama" class="form-control" @click="getNama">
                            <input type="text" id="nama_nip" class="form-control"  style="display:none">
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Level User</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <select class="form-control" v-model="profile.level">
                                <option>Administrator</option>
                                <option>Admin OPD</option>
                                <option>Pimpinan OPD</option>
                                <option>Bendahara</option>
                                <option>Client OPD</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>


                   <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Username</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <input v-model="dataku.username" type="text" class="form-control" >
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Password</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <input v-model="dataku.password" type="text" id="atasan" class="form-control" >
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Konfirmasi Password</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <input v-model="dataku.confirmPassword" type="text" id="atasan" class="form-control" >
                          </div>
                        </div>
                      </div>
                    </div>



                  </div>
                  <div class="modal-footer">
                    <button @click="addData" type="button" class="btn btn-info waves-effect">SIMPAN</button>
                    <button
                      type="button"
                      class="btn btn-danger waves-effect"
                      data-dismiss="modal"
                    >KEMBALI</button>
                  </div>
                </div>
              </div>
            </div>
          <!-- =========================================================== TAMBAH ================================================================= -->


          <!-- =========================================================== EDIT ================================================================= -->
            <!-- </div> -->
            <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-header bg-light-green">
                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                  </div>
                  <div class="modal-body">
                    <div v-if="errorMessage" class="alert alert-danger" role="alert">{{ errorMessage }}</div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Unit Kerja</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <input type="text" v-model="profile.unit_kerja" id="e_unit_kerja" class="form-control" >
                            <input type="text" v-model="profile.unit_kerja_id" id="e_unit_kerja_id" class="form-control"  style="display:none">
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Nama User</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <input type="text" v-model="profile.nama" id="e_nama" class="form-control" >
                            <input type="text" v-model="profile.nama_nip" id="e_nama_nip" class="form-control"  style="display:none">
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Level User</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <select class="form-control" v-model="profile.level">
                                <option>Administrator</option>
                                <option>Admin OPD</option>
                                <option>Pimpinan OPD</option>
                                <option>Bendahara</option>
                                <option>Client OPD</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>


                   <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Username</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <input v-model="dataku.username" type="text" id="atasan" class="form-control" >
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Password</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <input v-model="dataku.password" type="text" id="atasan" class="form-control" >
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                        <label for="kode">Konfirmasi Password</label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <div class="form-line">
                            <input v-model="dataku.confirmPassword" type="text" id="atasan" class="form-control" >
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                  <div class="modal-footer">
                    <button @click="editData" type="button" class="btn btn-success waves-effect">RUBAH</button>
                    <button
                      type="button"
                      class="btn btn-danger waves-effect"
                      data-dismiss="modal"
                    >KEMBALI</button>
                  </div>
                </div>
              </div>
            </div>
          <!-- =========================================================== EDIT ================================================================= -->



          <!-- =========================================================== LIHAT ================================================================= -->
            <!-- </div> -->
            <div class="modal fade" id="m_lihat_data" tabindex="-1" role="dialog">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-header bg-light-blue">
                    <h4 class="modal-title" id="largeModalLabel">DETIL DATA</h4>
                  </div>
                    <div class="modal-body">
                      <hr>
                      <div class="table-responsive">
                        <table class="table table-bordered" style="width: 100%">
                          <thead>
                            <tr class="bg-info">
                              <th style="width: 5%">No.</th>
                              <th style="width: 30%">Indikator</th>
                              <th style="width: 65%">Uraian</th>
                            </tr>
                          </thead>

                          <tbody>

                            <tr class="h_isitable">
                              <td>01.</td>
                              <td>Sekolah</td>
                              <td>{{profile.sekolah}}</td>
                            </tr>
                            <tr class="h_isitable">
                              <td>02.</td>
                              <td>Nama</td>
                              <td>{{profile.nama}}</td>
                            </tr>
                            <tr class="h_isitable">
                              <td>03.</td>
                              <td>Nip/Nik</td>
                              <td>{{profile.nip}}</td>
                            </tr>
                            <tr class="h_isitable">
                              <td>04.</td>
                              <td>Jabatan</td>
                              <td>{{profile.jabatan}}</td>
                            </tr>
                            <tr class="h_isitable">
                              <td>05.</td>
                              <td>Hp</td>
                              <td>{{profile.hp}}</td>
                            </tr>
                            <tr class="h_isitable">
                              <td>06.</td>
                              <td>Level User</td>
                              <td>{{profile.level}}</td>
                            </tr>

                          </tbody>
                        </table>
                      </div>

                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-danger waves-effect"
                      data-dismiss="modal"
                    >KEMBALI</button>
                  </div>
                </div>
              </div>
            </div>
          <!-- =========================================================== LIHAT ================================================================= -->



        <!-- ============================================================ MODAL ======================================================================== -->




      <!-- ============================================================ MULAI ======================================================================== -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
// const ADD_URL = URL_APP + "auth/signup";


import Joi from "joi";
const ADD_URL = URL_APP + "api/v1/users/";
const SIGNUP_URL = URL_APP + "auth/signup";




const schema = Joi.object().keys({
  username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(3).max(13).required(),
  password: Joi.string().min(6).required(),
});


export default {

  name : 'monev_user',
  data: function() {
    return {
      dataku: {
        username : "",
        password : "",
        confirmPassword: "",
      },

      profile:{
        id : "",
        unit_kerja : "",
        unit_kerja_id : "",
        nama : "",
        nama_nip : "",
        level : "Client OPD",
      },

      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",

      signingUp : false,
      errorMessage: "",
    };
  },

  methods: {
    getView: function() {
      fetch(ADD_URL + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
          // console.log(res_data);
        });
    },

    addData: function() {
      this.errorMessage = "";
        if (this.validUser()) {
            // Jika user sdh valid lakukan pengiriman data ke server
            const body = {
              username: this.dataku.username,
              password: this.dataku.password
            };
            this.signingUp = true;
            fetch(SIGNUP_URL, {
                method: "POST",
                body: JSON.stringify({

                  username: this.dataku.username,
                  password: this.dataku.password,

                  unit_kerja_id : document.getElementById("unit_kerja_id").value,
                  nama_nip :  document.getElementById("nama_nip").value,
                  level : this.profile.jabatan,

                }),
                headers: {
                    "content-type": "application/json"
                }
            }).then((response) => {
                this.getView();
                this.alertku("success", "sukses menambah data");
                if (response.ok) {
                  return response.json();
                }
                else{
                  return response.json().then(error => {
                    throw new Error(error.message);
                  });

                }
            })
            .catch((error) => {
              setTimeout(() => {
                this.signingUp = false;
                this.errorMessage = error.message;
              }, 1000);
            });
        }else{
          console.log("tidak valid");

        }

    },

    validUser : function(){
      if (this.dataku.password !== this.dataku.confirmPassword) {
          this.errorMessage = "Password harus sama. !";
          return false;
      }
      // Memulai proses validasi melalui skema Joi yang sebelumnya dibuat
      // req.body merupakan data yang di kirim oleh client dan schema merupakan skema joi yg di buat sebelumnya
      const body = {
              username: this.dataku.username,
              password: this.dataku.password
      };
      const result = Joi.validate(body, schema);

      if (result.error === null) {
          return true;
      }
      if (result.error.message.includes("username")) {
          // jika pesan error yang dihasilkan mengandung char "username" maka
          this.errorMessage = "Username tidak valid";
      } else {
          this.errorMessage = "Password tidak valid";
          console.log(result.error);

      }
      return false;
    },

    removeData: function(id_data) {
      fetch(ADD_URL + "remove", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({ _id: id_data })
      }).then(res_data => {
        this.getView();
        this.alertku("success", "sukses menghapus data");
        this.autocompleted();
      });
    },

    editData: function() {
      fetch(ADD_URL + "update", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          id : this.dataku.id,
          nama: document.getElementById("nama_nip").value,
          level: this.dataku.level,
          username: this.dataku.username,
          password: this.dataku.password,
        })
      }).then(res_data => {
        this.getView();
        this.alertku("success", "sukses merubah data");
        this.autocompleted();
      });
    },
    getEdit: function(type, status, sekolah, sekolah_id, nama, jabatan, alamat, hp, nip, id, level, username, password) {

        this.profile.sekolah = type+" "+status+" "+sekolah;
        this.profile.sekolah_id = sekolah_id;
        this.profile.nama = nama;
        this.profile.jabatan = jabatan;
        this.profile.alamat = alamat;
        this.profile.hp = hp;
        this.profile.nip = nip;
        this.profile.id = id;
        this.profile.level = level;

        this.dataku.username = username;
        this.dataku.password = password;

    },

  // ================== PAGINASI ====================
    alertku: function(type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function() {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function() {
      this.getView();
    },
    getNama : function(){
      var unit_Kerja = document.getElementById("unit_kerja_id").value;
      this.autocompleted1(unit_Kerja)
    },
    autocompleted : function(){
      $.ajax({
        url: URL_APP+'api/v1/simpeg_unit_kerja/',
        type: "GET",
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+localStorage.token,
        },
        success: function(result){

          horsey(document.querySelector('#unit_kerja'), {
            source: [{ list: result }],
            getText: 'unit_kerja',
            getValue: 'unit_kerja',
            renderItem: function (li, suggestion) {
              li.innerHTML = `<span class="body_auto">`+suggestion.unit_kerja+`</span><br>
              <span class="head_auto">(`+suggestion.detilInstansi.instansi+`)</span><br>`
            },
            predictNextSearch(info) {
              document.getElementById('unit_kerja_id').value= info.selection._id ;
            },
            limit: 10
          });

          horsey(document.querySelector('#e_unit_kerja'), {
            source: [{ list: result }],
            getText: 'sekolah',
            getValue: 'sekolah',
            renderItem: function (li, suggestion) {
              li.innerHTML = `<span class="body_auto">`+suggestion.type+` `+suggestion.status+` `+suggestion.sekolah+`</span> <br>
              <span class="head_auto">(`+suggestion.detilkecamatan.kecamatan+`-`+suggestion.detilkecamatan.detilkabupaten.kabupaten+`)</span><br>`
            },
            predictNextSearch(info) {
              document.getElementById('e_unit_kerja_id').value= info.selection.id ;
            },
            limit: 10
          });

      }});


    },

    autocompleted1 : function(unit_Kerja){
      fetch(URL_APP+'api/v1/simpeg_biodata/getView', {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
            unit_kerja: unit_Kerja,
          }),
        
      })
        .then(res => res.json())
        .then(res_data => {
          
          horsey(document.querySelector('#nama'), {
            source: [{ list: res_data }],
            getText: 'nama',
            getValue: 'nama',
            renderItem: function (li, suggestion) {
              li.innerHTML = `<span class="body_auto">`+suggestion.nama+`</span><br>
              <span class="head_auto">`+suggestion.nip+`</span><br>`
            },
            predictNextSearch(info) {
              document.getElementById('nama_nip').value= info.selection._id ;
            },
            limit: 10
          });

          horsey(document.querySelector('#e_nama'), {
            source: [{ list: res_data }],
            getText: 'nama',
            getValue: 'nama',
            renderItem: function (li, suggestion) {
              li.innerHTML = `<span class="body_auto">`+suggestion.nama+`</span><br>
              <span class="head_auto">`+suggestion.nip+`</span><br>`
            },
            predictNextSearch(info) {
              document.getElementById('e_nama_nip').value= info.selection._id ;
            },
            limit: 10
          });

        });

    },



  // ================== PAGINASI ====================
  },

  watch: {
        dataku: {
            handler() {
                this.errorMessage = "";
            },
            deep: true
        }
  },
  mounted: function() {
    localStorage.sidemenu = 'office';
    this.getView();
    this.autocompleted();
  }
};
</script>

<style>
</style>
